import React from 'react';

const BlurOverlay = ({ children, enabled = true, blurAmount = '4px', text = 'Em desenvolvimento' }) => {
  if (!enabled) return children;

  return (
    <div style={{ position: 'relative' }}>
      {children}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backdropFilter: `blur(${blurAmount})`,
          backgroundColor: 'rgba(255, 255, 255, 0.3)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
        aria-hidden="true"
      >
      <div style={{
          fontWeight: 'bold',
          padding: '8px 16px',
          borderRadius: '4px',
          backgroundColor: 'rgba(255, 255, 255, 0.7)',
          color: '#333'
        }}>
          {text}
        </div>
      </div>
      <style>
        {`
          @supports not (backdrop-filter: blur(4px)) {
            .blur-fallback {
              background-color: rgba(255, 255, 255, 0.8);
            }
          }
        `}
      </style>
    </div>
  );
};

export default BlurOverlay;
